import backend from '@common/backend';

const BASE = '/gradeTypes';

export interface IGetGradeTypesQuery {
	subject_id?: number;
	page?: number;
	limit?: number;
}

export const getGradeTypes = async (query: IGetGradeTypesQuery) => backend.get(`${BASE}/`, {
	params: query,
});

export const getGradeType = async (id: number) => backend.get(`${BASE}/${id}`);

export const postGradeType = async (data: any) => backend.post(`${BASE}`, data);

export const deleteGradeType = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveGradeType = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, data);

export const saveGradeTypes = async (data: any) => backend.put(`${BASE}/bulk`, data);

export const postGradeTypes = async (data: any) => backend.post(`${BASE}/bulk`, data);

export const copyGradeTypes = async (scheduleProgramId: number) => backend.put(`${BASE}/copy/${scheduleProgramId}`, {});
